module.exports = __webpack_public_path__ + "assets/0d0e1a1e3ec48a041697a738e7893eed.png";